export const getBanner = '/banners';
export const updateBanner = '/banners/update-status/';
export const addBanner = '/banners/add-banner';
export const deleteBanner = 'banners/';
